import { Component, OnInit } from '@angular/core';
import { Navigation } from '@angular/router';
import { Kios } from 'src/app/services/kios.service';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
  selector: 'app-kiosk',
  templateUrl: './kiosk.component.html',
 })
export class KioskComponent implements OnInit {

  constructor(
    private kios: Kios,
    private sideBar: NavigationService
    ) {}


  ngOnInit(): void {
    this.kios.enterKiosMode();
    this.sideBar.hide = true;
  }
}